// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202609040012/js/" + chunkId + "." + {"44":"601ddafc","225":"502a6b07","481":"57cd7b01","486":"f98e7cf4","770":"9775f909"}[chunkId] + ".0.37551109647910996.chunk.js";
};